import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withRouter } from 'react-router';

import moment from 'moment';
import lodashFind from 'lodash/fp/find';

import { numberWithCommas } from 'common/formatters';

import SrFilterTabList from 'client/components/SrFilterTabList';
import SrFilterCheckbox from 'client/components/SrFilterCheckbox';
import SrFilterCheckboxList from 'client/components/SrFilterCheckboxList';

@withRouter
class SrSearchItem extends React.Component {
  static propTypes = {
    id: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    multi: PropTypes.bool,
    value: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
      PropTypes.bool,
      PropTypes.array,
    ]),
    optionList: PropTypes.array,
    tabList: PropTypes.array,
    checkboxList: PropTypes.array,
    isDisable: PropTypes.bool,
    redirectTo: PropTypes.string.isRequired,
    onChange: PropTypes.func,
    history: PropTypes.object.isRequired,
  };

  render() {
    const {
      id,
      type,
      label,
      multi,
      value,
      optionList,
      tabList,
      checkboxList,
      isDisable,
      redirectTo,
      onChange,
      history,
    } = this.props;

    let valueDOM = null;
    let containerClassname = null;
    let shouldOpenFilterPage = false;

    if (type === 'tab-list') {
      valueDOM = (
        <SrFilterTabList
          id={id}
          tabList={tabList}
          value={value}
          onChange={onChange}
          multi={multi}
        />
      );

      containerClassname = 'tabs';
    }
    else if (type === 'checkbox-list') {
      valueDOM = (
        <SrFilterCheckboxList
          id={id}
          checkboxList={checkboxList}
          value={value}
          onChange={onChange}
        />
      );

      containerClassname = 'multi';
    }
    else if (type === 'checkbox') {
      valueDOM = (
        <SrFilterCheckbox
          id={id}
          value={value}
          onChange={onChange}
        />
      );

      containerClassname = 'switch';
    }
    else if (type === 'option-list') {
      let lbl = null;
      shouldOpenFilterPage = true;

      if (multi) {
        const optionValues = optionList
          .filter((option) => Array.isArray(value) ? value.includes(option.value) : false)
          .map((option) => option.label)
          .join(', ');
        lbl = optionValues || 'Any';
      }
      else {
        lbl = (lodashFind({ id: value }, optionList) || {}).label;
      }

      valueDOM = (
        <span className={classNames('value')}>{lbl || 'Any'}</span>
      );

      containerClassname = 'twoColumns';
    }
    else if (type === 'date') {
      shouldOpenFilterPage = true;

      valueDOM = (
        <span className={classNames('value')}>{value ? moment(value).format('MMMM Do, YYYY') : 'Any'}</span>
      );

      containerClassname = 'twoColumns';
    }
    else if (type === 'number') {
      shouldOpenFilterPage = true;

      valueDOM = (
        <span className={classNames('value')}>{value ? `$${numberWithCommas(value)}` : '--'}</span>
      );

      containerClassname = 'twoColumns';
    }
    else if (type === 'location') {
      shouldOpenFilterPage = true;
      containerClassname = 'twoColumns';

      valueDOM = (
        <span className={classNames('value')}>{value}</span>
      );
    }
    else {
      valueDOM = (
        <span
          className={classNames('value', {
            dropdown: type === 'dropdown',
          })}
        >{value}
        </span>
      );

      containerClassname = 'twoColumns';
    }

    return (
      <div
        className={classNames('row', containerClassname, { disabled: isDisable })}
        onClick={() => {
          if (!shouldOpenFilterPage || isDisable) return;
          history.push(`${redirectTo}/${id}`);
        }}
      >
        <span className='title'>{label}</span>
        {valueDOM}
      </div>
    );
  }
}

SrSearchItem.displayName = 'SrSearchItem';

export default SrSearchItem;
